module.exports = __webpack_public_path__ + "static/a_su-d944755d1dd66dcd6c48ada3d4730179.png";